<div class="container-fluid">
<div class="row">
	<div class="col-12 px-0">
		<div class="footer text-center">
			<p class="mb-0">All Rights Reserved © 2017 | Arrivae</p>
		</div>
	</div>
</div>
</div>



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/shared/customer-footer/customer-footer.component.html